import { createAction, props } from '@ngrx/store'
import { EventTicketPackageEntity, EventTicketPackagesResponse } from './event-ticket-packages.models'
import { HttpErrorResponse } from '@angular/common/http'
import { Update } from '@ngrx/entity'

export const loadEventTicketPackages = createAction(
  '[EventTicketPackages/Page] Load Event Ticket Packages',
  (offset?: number, limit?: number) => ({ offset, limit }),
)

export const loadEventTicketPackagesSuccess = createAction(
  '[EventTicketPackages/API] Load Event Ticket Packages Success',
  props<{
    response: EventTicketPackagesResponse
    offset: number
  }>(),
)

export const upsertEventTicketPackages = createAction(
  '[EventTicketPackages/API] Upsert Event Ticket Packages',
  props<{ eventTicketPackages: EventTicketPackageEntity[] }>(),
)

export const loadEventTicketPackagesFailure = createAction(
  '[EventTicketPackages/API] Load Event Ticket Packages Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const resyncEventTicketPackages = createAction(
  '[EventTicketPackages/API] Resync EventTicketPackages',
  (offset: number, onFocus = false) => ({
    offset,
    onFocus,
  }),
)

export const selectEventTicketPackage = createAction(
  '[EventTicketPackages/Page] Select Event Ticket Package',
  props<{ uuid: string }>(),
)

export const syncEventTicketPackage = createAction(
  '[EventTicketPackages/API] Sync Event Ticket Package',
  props<{ uuid: string }>(),
)

export const syncEventTicketPackageSuccess = createAction(
  '[EventTicketPackages/API] Sync Event Ticket Package Success',
  props<{ eventTicketPackage: EventTicketPackageEntity }>(),
)

export const syncEventTicketPackageFailure = createAction(
  '[EventTickets/API] Sync Event Ticket Package Failure',
  props<{ error: HttpErrorResponse; uuid?: string }>(),
)

export const upsertEventTicketPackage = createAction(
  '[EventTicketPackages/API] Upsert Event Ticket Package',
  props<{
    eventTicketPackage: EventTicketPackageEntity
  }>(),
)

export const navigateToEventTicketPackage = createAction(
  '[EventTicketPackages/Page] Navigate to Event Ticket Package',
  props<{ uuid: string; backPath?: string }>(),
)

export const clearSelectedEventTicketPackage = createAction(
  '[EventTicketPackages/Page] Clear Selected Event Ticket Package',
)

export const updateCount = createAction('[EventTicketPackages/API] Update Count', props<{ count: number }>())

export const updateOrderHash = createAction('[EventTicketPackages/API] Update Order Hash', props<{ order: string }>())

export const clearEventTicketPackages = createAction('[EventTicketPackages/API] Clear Event Ticket Packages')

export const addEventTicketPackage = createAction(
  '[EventTicketPackages/API] Add Event Ticket Package',
  props<{ eventTicketPackage: EventTicketPackageEntity }>(),
)

export const updateEventTicketPackage = createAction(
  '[EventTicketPackages/API] Update Event Ticket Package',
  props<{ update: Update<EventTicketPackageEntity> }>(),
)

export const deleteEventTicketPackage = createAction(
  '[EventTicketPackages/API] Delete Event Ticket Package',
  props<{ uuid: string }>(),
)

// Stale actions
export const setAllEventTicketPackagesStale = createAction(
  '[EventTicketPackages/Page] Set All Event Ticket Packages Stale',
)

export const removePageFromStale = createAction(
  '[EventTicketPackages/Page] Remove Page From Stale',
  props<{ page: number }>(),
)
